// Reusable Cinevoya logo component.
// - `mark` = true → renders only the round C-mark icon (square 1:1)
// - default → renders the full horizontal lockup (mark + wordmark + taglines)

export default function Logo({ size = 40, mark = false, className = "" }) {
  if (mark) {
    return (
      <img
        src="/cinevoya-mark.png"
        alt="Cinevoya"
        className={`select-none ${className}`}
        style={{ height: size, width: size, objectFit: "contain" }}
        draggable={false}
      />
    );
  }
  return (
    <img
      src="/cinevoya-logo-full.png"
      alt="Cinevoya"
      className={`select-none ${className}`}
      style={{ height: size, width: "auto" }}
      draggable={false}
    />
  );
}
